import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              AllChinaBuy Spreadsheet Guides &amp; Articles
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2 max-w-lg">
              In-depth SEO articles covering everything from beginner tutorials to advanced shopping strategies
            </p>
          </div>
          <Link
            to="/guide"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            View Shopping Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all hover:scale-[1.01] cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span>{article.readTime}</span>
                  <span>·</span>
                  <span>{article.dateModified}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.metaDescription}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-xs text-primary-600 font-medium">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}